import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import MobileBottomBar from "@/components/MobileBottomBar";
import { maybeFireAiReferralBeacon } from "@/lib/aiSources";

// Backend base URL — same convention as the rest of the SPA. Beacon hits
// /api/analytics/ai-referral if document.referrer matches a known AI
// assistant pattern (see lib/aiSources.js for the full pattern set).
const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  // Fire the AI-referral beacon ONCE per tab session on the first page
  // load. Subsequent in-app SPA navigations are NOT re-fired because the
  // user is the same session, and document.referrer doesn't change anyway.
  useEffect(() => {
    maybeFireAiReferralBeacon(API_BASE);
  }, []);

  // Routes under /embed/* are chromeless (no Header / Footer) so the page
  // can be safely loaded inside a third-party iframe. Every embed creates a
  // backlink + branded "Powered by HavenCostGuide" attribution.
  const isEmbed = pathname.startsWith("/embed/");
  if (isEmbed) {
    return <div className="min-h-screen bg-white">{children}</div>;
  }

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main className="flex-1 pb-16 md:pb-0" data-testid="main-content">
        {children}
      </main>
      <Footer />
      <BackToTop />
      <MobileBottomBar />
    </div>
  );
}
